/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';

import { Container } from './styles';
import Input from '~/components/Input';
import { IBatch } from '../Batches';
import { IModalityData } from '../Modalities';
import InputMask from '~/components/InputMask';

export interface IPricePlace {
  input_id: number;
  qtdPlaces?: number;
  expiration: Date;
}

interface IBatchError {
  batch_id: number;
  error: string;
}

export interface IBatchCategory {
  id: number;
  event_id: number;
  modality_id: number;
  category_id?: number;
  batch_id?: number;
  quantity: number;
  price: string;
  on?: boolean;
  quantity_sold: number;
}

interface IPricesPlaces {
  event_id: number;
  batches: IBatch[];
  modalities: IModalityData[];
  onChange(data: IPricePlace[], batchesCategories: IBatchCategory[]): void;
  statusName?: string;
  batchesCategories: IBatchCategory[];
}

const PricesPlaces: React.FC<IPricesPlaces> = ({
  event_id,
  batches: initialBatches,
  modalities,
  // onChange,
  // statusName,
  // batchesCategories: batchesCategoriesData,
}) => {
  const [batchesErrors, setBatchesErrors] = useState<IBatchError[]>([]);
  const [batches, setBatches] = useState<IBatch[]>([]);
  const [, setOldBatches] = useState<IBatch[]>([]);

  useEffect(() => {
    if (initialBatches && initialBatches.length > 0) {
      const newBatches = initialBatches.slice();
      let index = 0;
      for (const batch of newBatches) {
        for (const modality of modalities) {
          if (modality.categories) {
            for (const category of modality.categories) {
              let { batchesCategories } = batch;
              if (batchesCategories) {
                const batchCategoryIndex = batchesCategories.findIndex(
                  (batchCategory) =>
                    batchCategory.category_id === category.id &&
                    batchCategory.modality_id === modality.id
                );
                if (batchCategoryIndex === -1) {
                  batchesCategories.push({
                    id: new Date().getTime() * -1,
                    event_id,
                    batch_id: batch.input_id,
                    category_id: category.id as number,
                    modality_id: modality.id as number,
                    quantity: 0,
                    quantity_sold: 0,
                    price: '0',
                  });
                }
              } else {
                batchesCategories = [
                  {
                    id: new Date().getTime() * -1,
                    event_id,
                    batch_id: batch.input_id,
                    category_id: category.id as number,
                    modality_id: modality.id as number,
                    quantity: 0,
                    quantity_sold: 0,
                    price: '0',
                  },
                ];
              }

              newBatches[index].batchesCategories = batchesCategories;
            }
          }
        }

        index += 1;
      }

      setBatches(newBatches);
      setOldBatches(JSON.parse(JSON.stringify(newBatches)));
    }
  }, [event_id, initialBatches, modalities]);

  const handleChangeQuantity = useCallback(
    (e, category, batchIndex, modalityId) => {
      const newBatches = batches.slice();

      let total = newBatches[batchIndex].batchesCategories?.reduce(
        (previous, current) => {
          if (current.modality_id !== modalityId) {
            return previous + parseInt(current.quantity.toString(), 10);
          }
          if (
            current.category_id !== category.id &&
            current.modality_id === modalityId
          ) {
            return previous + parseInt(current.quantity.toString(), 10);
          }

          return previous;
        },
        0
      );
      total = (total || 0) + parseInt(e.target.value || '0', 10);

      setBatchesErrors((oldState) =>
        oldState.filter(
          (error) => error.batch_id !== newBatches[batchIndex].input_id
        )
      );

      newBatches[batchIndex] = {
        ...newBatches[batchIndex],
        restPlaces: (newBatches[batchIndex].qtdPlaces || 0) - total,
      };

      let batchCategoryIndex = newBatches[
        batchIndex
      ].batchesCategories?.findIndex(
        (batchCategory) =>
          batchCategory.category_id === category.id &&
          batchCategory.modality_id === modalityId
      );

      if (
        typeof batchCategoryIndex !== 'undefined' &&
        batchCategoryIndex >= 0
      ) {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories[batchCategoryIndex].quantity = parseInt(
            e.target.value,
            10
          );
          newBatches[batchIndex].batchesCategories = batchesCategories;
        }
      } else {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories.push({
            id: new Date().getTime() * -1,
            event_id,
            batch_id: newBatches[batchIndex].input_id,
            category_id: category.id,
            modality_id: modalityId,
            quantity: parseInt(e.target.value, 10),
            quantity_sold: 0,
            price: '0',
          });
          newBatches[batchIndex].batchesCategories = batchesCategories;
          batchCategoryIndex =
            newBatches[batchIndex].batchesCategories?.length || 0;
        } else {
          newBatches[batchIndex].batchesCategories = [
            {
              id: new Date().getTime() * -1,
              event_id,
              batch_id: newBatches[batchIndex].input_id,
              category_id: category.id,
              modality_id: modalityId,
              quantity: parseInt(e.target.value, 10),
              quantity_sold: 0,
              price: '0',
            },
          ];
          batchCategoryIndex = 0;
        }
      }

      setBatches(newBatches);
    },
    [batches, event_id]
  );

  const handleChangePrice = useCallback(
    (e, category, batchIndex, modalityId) => {
      const newBatches = batches.slice();

      const batchCategoryIndex = newBatches[
        batchIndex
      ].batchesCategories?.findIndex(
        (batchCategory) =>
          batchCategory.category_id === category.id &&
          batchCategory.modality_id === modalityId
      );

      if (
        typeof batchCategoryIndex !== 'undefined' &&
        batchCategoryIndex >= 0
      ) {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories[batchCategoryIndex].price = parseFloat(
            e.target.value
              .replace('R$', '')
              .replaceAll('.', '')
              .replace(',', '.')
          ).toFixed(2);
          newBatches[batchIndex].batchesCategories = batchesCategories;
        }
      } else {
        const { batchesCategories } = newBatches[batchIndex];
        if (batchesCategories) {
          batchesCategories.push({
            id: new Date().getTime() * -1,
            event_id,
            batch_id: newBatches[batchIndex].input_id,
            category_id: category.id,
            modality_id: modalityId,
            quantity: 0,
            quantity_sold: 0,
            price: parseFloat(
              e.target.value
                .replace('R$', '')
                .replaceAll('.', '')
                .replace(',', '.')
            ).toFixed(2),
          });
          newBatches[batchIndex].batchesCategories = batchesCategories;
        } else {
          newBatches[batchIndex].batchesCategories = [
            {
              id: new Date().getTime() * -1,
              event_id,
              batch_id: newBatches[batchIndex].input_id,
              category_id: category.id,
              modality_id: modalityId,
              quantity: 0,
              quantity_sold: 0,
              price: parseFloat(
                e.target.value
                  .replace('R$', '')
                  .replaceAll('.', '')
                  .replace(',', '.')
              ).toFixed(2),
            },
          ];
        }
      }

      setBatches(newBatches);
    },
    [batches, event_id]
  );

  return (
    <Container>
      <div className="col-12">
        <h2 className="h4 fw-semibold text-center mt-5 mb-5">
          7 - Preços e vagas
        </h2>
      </div>

      {batches.map((batch, index) => (
        <div key={batch.input_id} className="col-lg-6">
          <div className="bg-category p-3 mb-3">
            <h5 className="roboto h5 fw-semibold">Lote {index + 1}</h5>
            <p className="mb-0">
              Vagas: {batch.qtdPlaces || 0} | Validade:{' '}
              {format(batch.expiration, 'dd/MM/yyyy')}
            </p>
          </div>
          {modalities.map((modality) => (
            <Fragment key={modality.id}>
              {modality.categories?.map((category) => (
                <div
                  key={category.id}
                  className="bd-lots mb-3 p-3 d-flex justify-content-between align-items-center"
                >
                  <h3 className="h6 mb-0 fw-semibold roboto d-flex align-items-center">
                    {modality.name}: {category.name}
                  </h3>
                  <div className="qty-size">
                    <span className="w-75 mx-auto roboto h6 fw-normal mb-2 d-block">
                      Qtd. de vagas
                    </span>
                    <Input
                      type="number"
                      name="qtd-places"
                      placeholder="0"
                      onChange={(e) =>
                        handleChangeQuantity(e, category, index, modality.id)
                      }
                      className={`${
                        !!batchesErrors.find(
                          (batchError) => batchError.batch_id === batch.input_id
                        )?.error && 'border-danger'
                      } w-75 mx-auto input`}
                      min={0}
                      max={
                        (batch.restPlaces || 0) +
                        (batch.batchesCategories
                          ? batch.batchesCategories[
                              batch.batchesCategories?.findIndex(
                                (batchCategory) =>
                                  batchCategory.category_id === category.id &&
                                  batchCategory.modality_id === modality.id
                              )
                            ]?.quantity || 0
                          : 0)
                      }
                      defaultValue={
                        batch.batchesCategories?.find(
                          (batchCategory) =>
                            batchCategory.category_id === category.id &&
                            batchCategory.modality_id === modality.id
                        )?.quantity
                      }
                      onWheel={(e: any) => e.target.blur()}
                    />
                    <small className="d-block text-center text-danger">
                      {
                        batchesErrors.find(
                          (batchError) => batchError.batch_id === batch.input_id
                        )?.error
                      }
                    </small>
                  </div>
                  <div>
                    <span className="w-75 mx-auto roboto h6 fw-normal mb-2 d-block">
                      Preços
                    </span>
                    <InputMask
                      kind="money"
                      name="price"
                      placeholder="R$ 0,00"
                      onChange={(e) =>
                        handleChangePrice(e, category, index, modality.id)
                      }
                      className="w-75 mx-auto input"
                      value={
                        batch.batchesCategories?.find(
                          (batchCategory) =>
                            batchCategory.category_id === category.id &&
                            batchCategory.modality_id === modality.id
                        )?.price
                      }
                    />
                  </div>
                </div>
              ))}
            </Fragment>
          ))}
        </div>
      ))}
    </Container>
  );
};

export default PricesPlaces;
